if ("serviceWorker" in window.navigator) {
  // window.navigator.serviceWorker.register("./service-worker.js").then(() => {}, () => {});
}